import { render, staticRenderFns } from "./all_uk_ireland.vue?vue&type=template&id=7c3a435e&scoped=true"
import script from "./all_uk_ireland.vue?vue&type=script&lang=js"
export * from "./all_uk_ireland.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3a435e",
  null
  
)

export default component.exports